import { shallowRef } from 'vue';
import { format } from 'date-fns';
import { enUS, es, ptBR } from 'date-fns/locale';

// date-fns writes English unless it is handed a locale, and upstream calls it
// without one. The dashboard entrypoint keeps this in sync with vue-i18n, and
// timeHelper reads it on every call. A ref, so computeds that format a date
// re-render when the user switches language.
const DATE_FNS_LOCALES = { pt_BR: ptBR, es };

const current = shallowRef(enUS);

export const setDateLocale = code => {
  current.value = DATE_FNS_LOCALES[code] || enUS;
};

export const dateLocale = () => current.value;

// Upstream's patterns are written for English: month before day and a 12-hour
// clock ("Oct 13, 9:00 AM"). The other languages we ship read day first on a
// 24-hour clock ("13 de out, 09:00"), so their patterns are rewritten here.
export const localizePattern = pattern => {
  if (current.value === enUS) return pattern;
  return pattern
    .replace(/h{1,2}[:.]mm ?a+/g, 'HH:mm')
    .replace(/(MMM|LLL) d,? (y+)/g, "d 'de' $1 'de' $2")
    .replace(/(MMM|LLL) d\b/g, "d 'de' $1");
};

export const formatLocalized = (date, pattern) =>
  format(date, localizePattern(pattern), { locale: current.value });
